import React, { Fragment } from 'react';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Step {
  title: string;
  description: string;
  calculate?: boolean;
}
interface WizardFormProps {
  steps: Step[];
  currentStep: number;
  onStepChange: (step: number) => void;
  onSubmit: () => void;
  children: React.ReactNode;
  nextDisabled?: boolean;
  nextDisabledReason?: string;
}
export function WizardForm({
  steps,
  currentStep,
  onStepChange,
  onSubmit,
  children,
  nextDisabled = false,
  nextDisabledReason
}: WizardFormProps) {
  const progress = (currentStep + 1) / steps.length * 100;
  return <div className="bg-white rounded-lg border border-gray-200" data-id="element-307" data-mp="sx7g2ffsiiny">
      {/* Step Indicator */}
      <div className="p-6 border-b border-gray-200" data-id="element-308" data-mp="xq0md7qwpz25">
        <div className="flex items-center justify-between mb-4" data-id="element-309" data-mp="xqtmhpvd1qbb">
          {steps.map((step, idx) => <Fragment key={idx} data-id="element-310" data-mp="58oa46k7qhz1" data-mpi={idx}>
              <div className="flex flex-col items-center" data-id="element-311" data-mp="57wc6p35885l">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold mb-2 ${idx < currentStep ? 'bg-[#1B5E20] text-white' : idx === currentStep ? 'bg-[#1B5E20] text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-312" data-mp="56bkr8c4l5by">
                  {idx < currentStep ? <CheckIcon size={20} data-id="element-313" data-mp="39dd7l03y9z70" /> : idx + 1}
                </div>
                <div className={`text-xs font-medium ${idx <= currentStep ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-314" data-mp="34gd0clvd6qeb">
                  {step.title}
                </div>
              </div>
              {idx < steps.length - 1 && <div className={`flex-1 h-0.5 mx-4 ${idx < currentStep ? 'bg-[#1B5E20]' : 'bg-gray-200'}`} data-id="element-315" data-mp="2qg2b1n9pdjv9" />}
            </Fragment>)}
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-316" data-mp="oofopz0rad54">
          <div className="bg-[#1B5E20] h-2 rounded-full transition-all duration-300" style={{
          width: `${progress}%`
        }} data-id="element-317" data-mp="jqe5ne3bydtn" />
        </div>
      </div>

      {/* Step Content */}
      <div className="p-6" data-id="element-318" data-mp="2iye5695hoeg7">
        <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-319" data-mp="2iynk91ozx174">
          {steps[currentStep].title}
        </h2>
        <p className="text-sm text-gray-600 mb-6" data-id="element-320" data-mp="246c08aokav9b">
          {steps[currentStep].description}
        </p>
        <div data-id="element-321" data-mp="2956qfxouzm3g">{children}</div>
      </div>

      {/* Navigation */}
      <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-322" data-mp="2wyf2xfqgj5rg">
        <button onClick={() => onStepChange(currentStep - 1)} disabled={currentStep === 0} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-323" data-mp="31uvvcm4ow6ac">
          <ChevronLeftIcon size={16} data-id="element-324" data-mp="1bjhruc50rmc7" />
          Back
        </button>
        {currentStep === steps.length - 1 ? <button onClick={onSubmit} className="flex items-center gap-2 px-6 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] transition-colors" data-id="element-325" data-mp="1gjncv9gsaalb">
            Submit
          </button> : <div className="flex items-center gap-3" data-id="element-326" data-mp="3ptwfsrlhy8c6">
            {nextDisabled && nextDisabledReason && <span className="text-xs text-red-600 font-medium max-w-xs text-right" data-id="element-327" data-mp="3kc0nzez2xe6">
                {nextDisabledReason}
              </span>}
            <button onClick={() => onStepChange(currentStep + 1)} disabled={nextDisabled} className="flex items-center gap-2 px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-328" data-mp="3c0nb348huazz">
              Next
              <ChevronRightIcon size={16} data-id="element-329" data-mp="3fzw2w3jz3ysw" />
            </button>
          </div>}
      </div>
    </div>;
}